import React, { Component } from 'react';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Footer } from './component/Footer';
import { Navbar } from './component/Navbar';
import { Home } from './Home'
import { Info } from './component/Info';
import { CpIntro } from './component/CpIntro';
import { JobList } from './component/JobList';
import { JobRegSelect } from './component/JobRegSelect';
import { Job } from './component/Job';
import { JobHome } from './component/JobHome';
import { PersonList } from './component/PersonList';
import { Person } from './component/Person';
import { PersonHome } from './component/PersonHome';
import { PersonRegSelect } from './component/PersonRegSelect';
//MAP - 지도
import { MapHome } from './component/map/MapHome';

//BLOG - 블로그 
import { BlogList } from './component/BlogList';
import { BlogListAdmin } from './component/admin/BlogListAdmin';
import { BlogRegAdmin } from './component/admin/BlogRegAdmin';
import { BlogModiAdmin } from './component/admin/BlogModiAdmin';
import { Blog } from './component/Blog';
import { BlogAdmin } from './component/admin/BlogAdmin';
import { RedirectToNewUrlBlog } from './component/common/RedirectToNewUrl'

//NEWS - 뉴스
import { NewsList } from './component/NewsList';
import { NewsListAdmin } from './component/admin/NewsListAdmin';
import { NewsRegAdmin } from './component/admin/NewsRegAdmin';
import { NewsModiAdmin } from './component/admin/NewsModiAdmin';
import { News } from './component/News';
import { NewsAdmin } from './component/admin/NewsAdmin';
import { RedirectToNewUrlNews } from './component/common/RedirectToNewUrl'

//NOTICE - 공지사항 
import { NoticeList } from './component/NoticeList';
import { NoticeListAdmin } from './component/admin/NoticeListAdmin';
import { NoticeRegAdmin } from './component/admin/NoticeRegAdmin';
import { NoticeModiAdmin } from './component/admin/NoticeModiAdmin';
import { NoticeAdmin } from './component/admin/NoticeAdmin';
import { Notice } from './component/Notice';

import { MbrCpReg } from './component/MbrCpReg';
import { MbrPvReg } from './component/MbrPvReg';
import { MbrPvRegValidation } from './component/MbrPvRegValidation';
import { MbrCpRegValidation } from './component/MbrCpRegValidation';
import { MbrSelect } from './component/MbrSelect';

//Mypage - 마이페이지
import { MbrCpMypage } from './component/mypage/MbrCpMypage';
import { MbrCpModiMypage } from './component/mypage/MbrCpModiMypage';
import { MbrPvMypage } from './component/mypage/MbrPvMypage';
import { MbrPvModiMypage } from './component/mypage/MbrPvModiMypage';
import { MbrAdminPage } from './component/admin/MbrAdminPage';

//Mypage - 마이페이지 - 채용정보
import { JobListMypage } from './component/mypage/JobListMypage';
import { JobRegMypage } from './component/mypage/JobRegMypage';
import { JobRegPremiumMypage } from './component/mypage/JobRegPremiumMypage';
import { JobModiMypage } from './component/mypage/JobModiMypage';

//Mypage - 마이페이지 - 인재정보
import { PersonListMypage } from './component/mypage/PersonListMypage';
import { PersonRegMypage } from './component/mypage/PersonRegMypage';
import { PersonModiMypage } from './component/mypage/PersonModiMypage';
import { PersonRegPremiumMypage } from './component/mypage/PersonRegPremiumMypage';

//Mypage - 마이페이지 - 한인 전문가
import { TalentRegMypage } from './component/mypage/talent/TalentRegMypage';
import { TalentEditMypage } from './component/mypage/talent/TalentEditMypage';
import { TalentListMypage } from './component/mypage/talent/TalentListMypage';
import { TalentMypage } from './component/mypage/talent/TalentMypage';

//어드민 페이지
import { MbrCpRegByAdmin } from './component/admin/MbrCpRegByAdmin';
import { ChangePwdByAdmin } from './component/admin/ChangePwdByAdmin';

import { LogIn } from './component/LogIn';
//import { LogInReturn } from './component/LogInReturn';
import { FindPwd } from './component/FindPwd';
import { FindUserId } from './component/FindUserId';
import { JobListPostReady } from './component/admin/JobListPostReady';
import { PersonListPostReady } from './component/admin/PersonListPostReady';

//커뮤니티
import { CmtyHome } from './component/community/CmtyHome';
import { CmtyJob } from './component/community/catg/CmtyJob';
//import { CmtyBiz } from './component/community/catg/CmtyBiz';
import { CmtyVisa } from './component/community/catg/CmtyVisa';
import { CmtyLang } from './component/community/catg/CmtyLang';
import { CmtyStudy } from './component/community/catg/CmtyStudy';
import { CmtyLife } from './component/community/catg/CmtyLife';
import { CmtyHouse } from './component/community/catg/CmtyHouse';
// import { CmtyMarket } from './component/community/catg/CmtyMarket';
// import { CmtyEvent } from './component/community/catg/CmtyEvent';
// import { CmtyEat } from './component/community/catg/CmtyEat';
// import { CmtyMeet } from './component/community/catg/CmtyMeet';
import { CmtyHealthcare } from './component/community/catg/CmtyHealthcare';
import { CmtyInsurance } from './component/community/catg/CmtyInsurance';
import { CmtyBank } from './component/community/catg/CmtyBank';

import { CmtyBaseRegPost } from './component/community/CmtyBaseRegPost';
import { CmtyBaseEditPost } from './component/community/CmtyBaseEditPost';
import { CmtyBasePost } from './component/community/CmtyBasePost';

//멘토링
import { MentorHome } from './component/mentor/MentorHome';
import { SupportHome } from './component/support/SupportHome';

//한인 전문가
import { TalentService } from './component/talent/TalentService'
import { TalentList } from './component/talent/TalentList'
import { TalentRegSelect } from './component/talent/TalentRegSelect'

///////////////////////////////////////////////////////////////////////////////////////

import 'leaflet/dist/leaflet.css';
import L from 'leaflet'; // Leaflet 라이브러리를 임포트합니다.
// 기본 아이콘 이미지 경로를 수정합니다.
// 이 부분은 Leaflet의 기본 아이콘 경로를 수동으로 지정하여 번들러가 파일을 찾을 수 있도록 돕습니다.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

class App extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <div className="app-wrapper">
        <Navbar />
        <div className="content">
          <NavRoutes />
        </div>
        <Footer />
      </div>
    );
  }
}

const NavRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route exact path='/' element={<Home />}></Route>
      {/* <Route exact path='/home' element={ <Home/> }></Route> */}
      <Route exact path='/cp_intro' element={<CpIntro />}></Route>
      <Route exact path='/info' element={<Info />}></Route>
      <Route exact path='/job_list' element={<JobList />}></Route>
      {/* <Route exact path='/job/:id' element={ <Job/> }></Route> */}
      <Route exact path='/job' element={<Job />}></Route>
      <Route exact path='/jobHome' element={<JobHome />}></Route>
      <Route exact path='/job_reg_select' element={<JobRegSelect />}></Route>
      <Route exact path='/person_list' element={<PersonList />}></Route>
      <Route exact path='/person' element={<Person />}></Route>
      <Route exact path='/personHome' element={<PersonHome />}></Route>
      <Route exact path='/person_reg_select' element={<PersonRegSelect />}></Route>
      {/* MAP - 지도 */}
      <Route exact path='/map_home' element={<MapHome />}></Route>

      {/* BLOG - 블로그 */}
      <Route exact path='/blog_list_admin' element={<BlogListAdmin />}></Route>
      <Route exact path='/blog_reg_admin' element={<BlogRegAdmin />}></Route>
      <Route exact path='/blog_modi_admin' element={<BlogModiAdmin />}></Route>
      <Route exact path='/blog_list' element={<BlogList />}></Route>
      <Route exact path='/blog' element={<RedirectToNewUrlBlog />}></Route>
      <Route path="/blog/:id/:slug" element={<Blog />} />
      <Route exact path='/blog_admin' element={<BlogAdmin />}></Route>

      {/* NEWS - 뉴스 */}
      <Route exact path='/news_list_admin' element={<NewsListAdmin />}></Route>
      <Route exact path='/news_reg_admin' element={<NewsRegAdmin />}></Route>
      <Route exact path='/news_modi_admin' element={<NewsModiAdmin />}></Route>
      <Route exact path='/news_list' element={<NewsList />}></Route>
      <Route exact path='/news' element={<RedirectToNewUrlNews />}></Route>
      <Route path="/news/:id/:slug" element={<News />} />
      <Route exact path='/news_admin' element={<NewsAdmin />}></Route>

      {/* NOTICE - 공지사항 */}
      <Route exact path='/notice_list' element={<NoticeList />}></Route>
      <Route exact path='/notice_list_admin' element={<NoticeListAdmin />}></Route>
      <Route exact path='/notice_reg_admin' element={<NoticeRegAdmin />}></Route>
      <Route exact path='/notice_modi_admin' element={<NoticeModiAdmin />}></Route>
      <Route exact path='/notice_admin' element={<NoticeAdmin />}></Route>
      <Route exact path='/notice' element={<Notice />}></Route>

      <Route exact path='/mbr_cp_reg' element={<MbrCpReg />}></Route>
      <Route exact path='/mbr_pv_reg' element={<MbrPvReg />}></Route>
      <Route exact path='/mbr_pv_reg_validation' element={<MbrPvRegValidation />}></Route>
      <Route exact path='/mbr_cp_reg_validation' element={<MbrCpRegValidation />}></Route>
      <Route exact path='/mbr_select' element={<MbrSelect />}></Route>

      {/*Mypage - 마이페이지 - 회원정보 */}
      <Route exact path='/mbr_cp_mypage' element={<MbrCpMypage />}></Route>
      <Route exact path='/mbr_cp_modi_mypage' element={<MbrCpModiMypage />}></Route>
      <Route exact path='/mbr_pv_mypage' element={<MbrPvMypage />}></Route>
      <Route exact path='/mbr_pv_modi_mypage' element={<MbrPvModiMypage />}></Route>
      <Route exact path='/mbr_admin_page' element={<MbrAdminPage />}></Route>

      {/*Mypage - 마이페이지 - 채용정보 */}
      <Route exact path='/job_list_mypage' element={<JobListMypage />}></Route>
      <Route exact path='/job_reg_mypage' element={<JobRegMypage />}></Route>
      <Route exact path='/job_reg_premium_mypage' element={<JobRegPremiumMypage />}></Route>
      <Route exact path='/job_modi_mypage' element={<JobModiMypage />}></Route>

      {/*Mypage - 마이페이지 - 인재정보 */}
      <Route exact path='/person_list_mypage' element={<PersonListMypage />}></Route>
      <Route exact path='/person_reg_mypage' element={<PersonRegMypage />}></Route>
      <Route exact path='/person_reg_premium_mypage' element={<PersonRegPremiumMypage />}></Route>
      <Route exact path='/person_modi_mypage' element={<PersonModiMypage />}></Route>

      {/*Mypage - 마이페이지 - 한인 전문가 */}
      <Route exact path='/talent_reg_mypage' element={<TalentRegMypage />}></Route>
      <Route exact path='/talent_edit_mypage/:regId' element={<TalentEditMypage />}></Route>
      <Route exact path='/talent_list_mypage' element={<TalentListMypage />}></Route>
      <Route exact path='/talent_mypage/:regId' element={<TalentMypage />}></Route>

      {/* ADMIN - 관리자 */}
      <Route exact path='/mbr_cp_reg_by_admin' element={<MbrCpRegByAdmin />}></Route>
      <Route exact path='/change_pwd_by_admin' element={<ChangePwdByAdmin />}></Route>
      <Route exact path='/job_list_post_ready' element={<JobListPostReady />}></Route>
      <Route exact path='/person_list_post_ready' element={<PersonListPostReady />}></Route>

      <Route exact path='/login' element={<LogIn />}></Route>
      {/* <Route exact path='/loginReturn' element={ <LogInReturn/> }></Route> */}
      <Route exact path='/find_pwd' element={<FindPwd />}></Route>
      <Route exact path='/find_userid' element={<FindUserId />}></Route>

      {/* CMTY - 커뮤니티 */}
      <Route exact path='/cmty_home' element={<CmtyHome />}></Route>
      <Route exact path='/cmty_job' element={<CmtyJob />}></Route>
      {/* <Route exact path='/cmty_biz' element={ <CmtyBiz/> }></Route> */}
      <Route exact path='/cmty_visa' element={<CmtyVisa />}></Route>
      <Route exact path='/cmty_lang' element={<CmtyLang />}></Route>
      <Route exact path='/cmty_study' element={<CmtyStudy />}></Route>
      <Route exact path='/cmty_life' element={<CmtyLife />}></Route>
      <Route exact path='/cmty_house' element={<CmtyHouse />}></Route>
      {/*
    <Route exact path='/cmty_market' element={ <CmtyMarket/> }></Route>
    <Route exact path='/cmty_event' element={ <CmtyEvent/> }></Route>
    <Route exact path='/cmty_eat' element={ <CmtyEat/> }></Route>
    <Route exact path='/cmty_meet' element={ <CmtyMeet/> }></Route> */}
      <Route exact path='/cmty_healthcare' element={<CmtyHealthcare />}></Route>
      <Route exact path='/cmty_insurance' element={<CmtyInsurance />}></Route>
      <Route exact path='/cmty_bank' element={<CmtyBank />}></Route>

      <Route exact path='/cmty_reg_post' element={<CmtyBaseRegPost />}></Route>
      <Route exact path='/cmty_base_post' element={<CmtyBasePost />}></Route>
      <Route exact path='/cmty_edit_post' element={<CmtyBaseEditPost />}></Route>

      {/* Mentoring - 멘토링 */}
      <Route exact path='/mentoring' element={<MentorHome />}></Route>
      <Route exact path='/support' element={<SupportHome />}></Route>

      {/* 한인 전문가 */}
      <Route exact path='/talent_service/:regId' element={<TalentService />}></Route>
      <Route exact path='/talent_list' element={<TalentList />}></Route>
      <Route exact path='/talent_reg_select' element={<TalentRegSelect />}></Route>
    </Routes>
  </BrowserRouter>
);

export default App;
